import { render } from "./ShipmentDetails.vue?vue&type=template&id=6d9302cb&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"

import "./ShipmentDetails.vue?vue&type=style&index=0&id=6d9302cb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9302cb"]])

export default __exports__